import { Enfant } from './enfant';
import { Parent } from './parent';
import { Creneau, Jours } from './creneau';
import { Entreprise } from './entreprise';

export class Modes {
    static PARTICULIER = 'particulier';
    static ENTREPRISE = 'entreprise';
}

export class Demande {

    dateEntree: Date;
    dateDemande: Date;
    mode: string; 

    enfant: Enfant;

    numeroAllocataire: string;

    parent1: Parent;
    parent2: Parent;
    entreprise: Entreprise;

    planning: Creneau[];
    revenus: number;
    enfantsACharge: number;

    complements: string;
    
    source: string;
    sourceAutre: string;

    consentement: boolean;
    
    constructor() {
        this.enfant = new Enfant();
        this.parent1 = new Parent();
        this.parent2 = new Parent();
        
        this.mode = Modes.PARTICULIER;
        this.entreprise = null;

        this.planning = [];
        this.planning.push(new Creneau(Jours.LUNDI))
        this.planning.push(new Creneau(Jours.MARDI))
        this.planning.push(new Creneau(Jours.MERCREDI))
        this.planning.push(new Creneau(Jours.JEUDI))
        this.planning.push(new Creneau(Jours.VENDREDI))
    }
}